import React, { useEffect, useState } from 'react'
// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import logoDark from "../../assets/images/logo-dark.png";
import logoLight from "../../assets/images/logo-light.png";


// action
import { registerUser, apiError } from "../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import { Link, useNavigate } from "react-router-dom";
import { Alert, Card, CardBody, Col, Container, Form, FormFeedback, Input, Label, Row } from 'reactstrap';

const Register = props => {
  //meta title
  document.title = "Register | My Urban Farms";

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
      username: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      username: Yup.string().required("Please Enter Your Username"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      dispatch(registerUser(values));
    }
  });

  const selectAccountState = (state) => state.Account;
  const AccountProperties = createSelector(
    selectAccountState,
    (account) => ({
      user: account.user,
      registrationError: account.registrationError,
      success: account.success
    })
  );

  const {
    user,
    registrationError, 
    success
  } = useSelector(AccountProperties);

  useEffect(() => {
    dispatch(apiError(""));
  }, [dispatch]);

  useEffect(() => {
    success && setTimeout(() => navigate("/login"), 2000)
  }, [success, navigate])

  return (
    <React.Fragment>
      <style>{`
 

      
        @keyframes floatOrb {
          0%, 100% { 
            transform: translate(0, 0) scale(1);
            opacity: 0.6;
          }
          33% { 
            transform: translate(30px, -30px) scale(1.1);
            opacity: 0.4;
          }
          66% { 
            transform: translate(-20px, 20px) scale(0.95);
            opacity: 0.5;
          }
        }


        .glassmorphic-card {
          backdrop-filter: blur(30px) saturate(180%);
          background: rgba(255, 255, 255, 0.15) !important;
          border: 2px solid rgba(255, 255, 255, 0.25) !important;
          border-radius: 28px !important;
          box-shadow: 0 30px 60px -15px rgba(0, 0, 0, 0.3),
                      0 0 0 1px rgba(255, 255, 255, 0.1) inset !important;
          overflow: visible !important;
          position: relative;
        }







        .register-subtitle {
          text-align: center;
          color: rgba(255, 255, 255, 0.85);
          font-size: 14px;
          margin-bottom: 2rem;
          font-weight: 500;
        }


        


        .glassmorphic-input::placeholder {
          color: rgba(255, 255, 255, 0.55) !important;
        }

        .glassmorphic-input:focus {
          background: rgba(255, 255, 255, 0.18) !important;
          border-color: rgba(255, 255, 255, 0.5) !important;
          box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.1),
                      0 6px 20px rgba(0, 0, 0, 0.12) !important;
          color: white !important;
          transform: translateY(-1px);
        }

        .glassmorphic-input.is-invalid {
          border-color: #ff6b6b !important;
          box-shadow: 0 0 0 3px rgba(255, 107, 107, 0.2) !important;
        }

        .password-toggle-btn {
          position: absolute;
          right: 18px;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          color: rgba(255, 255, 255, 0.75);
          cursor: pointer;
          padding: 6px;
          font-size: 20px;
          z-index: 1;
          transition: all 0.3s ease;
          border-radius: 8px;
        }

        .password-toggle-btn:hover {
          color: white;
          background: rgba(255, 255, 255, 0.1);
        }

        .glassmorphic-link {
          color: rgba(255, 255, 255, 0.95);
          font-weight: 500;
          transition: all 0.3s ease;
        }

        .glassmorphic-link:hover {
          color: white;
          text-decoration: underline;
        }


 

        .glassmorphic-btn:active {
          transform: translateY(0);
          box-shadow: 0 4px 12px rgba(91, 116, 99, 0.4);
        }

        .terms-text {
          text-align: center;
          color: rgba(255, 255, 255, 0.8);
          font-size: 13px;
          margin-top: 1.5rem;
          font-weight: 500;
        }

        .login-text {
          text-align: center;
          color: rgba(255, 255, 255, 0.8);
          font-size: 14px;
          margin-top: 1.5rem;
          font-weight: 500;
        }

        .login-link {
          color: white;
          font-weight: 700;
          text-decoration: none;
          padding: 4px 8px;
          border-radius: 6px;
          transition: all 0.3s ease;
        }

        .login-link:hover {
          background: rgba(255, 255, 255, 0.15);
          text-decoration: none;
          color: white;
        }

        .decorative-circle-1 {
          position: absolute;
          bottom: -30px;
          left: -30px;
          width: 120px;
          height: 120px;
          background: radial-gradient(circle, rgba(210, 221, 213, 0.4), transparent);
          border-radius: 50%;
          filter: blur(40px);
        }

        .decorative-circle-2 {
          position: absolute;
          top: -30px;
          right: -30px;
          width: 150px;
          height: 150px;
          background: radial-gradient(circle, rgba(122, 143, 126, 0.5), transparent);
          border-radius: 50%;
          filter: blur(45px);
        }



        .alert-success-glass {
          background: rgba(34, 197, 94, 0.25) !important;
          border: 1.5px solid rgba(34, 197, 94, 0.4) !important;
          color: white !important;
          border-radius: 14px !important;
          backdrop-filter: blur(10px);
          box-shadow: 0 4px 12px rgba(34, 197, 94, 0.2);
          font-weight: 500;
        }

        /* Subtle shimmer effect on card */
        @keyframes shimmer {
          0% { background-position: -1000px 0; }
          100% { background-position: 1000px 0; }
        }

        .glassmorphic-card::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.03), transparent);
          background-size: 1000px 100%;
          animation: shimmer 6s infinite;
          border-radius: 28px;
          pointer-events: none;
        }
      `}</style>

      <div className="glassmorphic-register-page" >
        {/* Glowing orbs */}
        <div className="glowing-orb-1"></div>
        <div className="glowing-orb-2"></div>
        <div className="glowing-orb-3"></div>

        {/* Landscape silhouettes */}
        {/* <svg className="landscape-svg" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path 
            fill="#4a6152" 
            fillOpacity="0.35" 
            d="M0,192L48,197.3C96,203,192,213,288,229.3C384,245,480,267,576,250.7C672,235,768,181,864,181.3C960,181,1056,235,1152,234.7C1248,235,1344,181,1392,154.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
        <svg className="landscape-svg" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path 
            fill="#5b7463" 
            fillOpacity="0.55" 
            d="M0,160L48,170.7C96,181,192,203,288,208C384,213,480,203,576,170.7C672,139,768,85,864,80C960,75,1056,117,1152,138.7C1248,160,1344,160,1392,160L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg> */}

        <Container style={{ position: 'relative', zIndex: 4 }}>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5} style={{ position: 'relative', zIndex: 10 }}>
             
              <Card className="glassmorphic-card">
                <CardBody>
                   <div className="logo-container">
                    <img src={logoLight} width={100} alt="Logo" />
                  </div>
                  <h1 className="register-title">Register</h1>
                  <div className="title-underline"></div>
                  <p className="register-subtitle">Get your free account now</p>

                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    {user && user ? (
                      <Alert className="alert-success-glass">
                        Register User Successfully
                      </Alert>
                    ) : null}

                    {registrationError && registrationError ? (
                      <Alert className="alert-glass">{registrationError}</Alert>
                    ) : null}
                    
                    <div className="glassmorphic-input-wrapper">
                      <i className="mdi mdi-email-outline glassmorphic-input-icon"></i>
                      <Input
                        id="email"
                        name="email"
                        className="glassmorphic-input"
                        placeholder="Email"
                        type="email"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email || ""}
                        invalid={
                          validation.touched.email && validation.errors.email ? true : false
                        }
                      />
                      {validation.touched.email && validation.errors.email ? (
                        <FormFeedback className="error-text">{validation.errors.email}</FormFeedback>
                      ) : null}
                    </div>

                    <div className="glassmorphic-input-wrapper">
                      <i className="mdi mdi-account-outline glassmorphic-input-icon"></i>
                      
                      <Input
                        name="username"
                        className="glassmorphic-input"
                        placeholder="Username"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.username || ""}
                        invalid={
                          validation.touched.username && validation.errors.username ? true : false
                        }
                      />
                      {validation.touched.username && validation.errors.username ? (
                        <FormFeedback className="error-text">{validation.errors.username}</FormFeedback>
                      ) : null}
                    </div>

                    <div className="glassmorphic-input-wrapper">
                      <i className="mdi mdi-lock-outline glassmorphic-input-icon"></i>
                      <Input
                        name="password"
                        value={validation.values.password || ""}
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        className="glassmorphic-input"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        invalid={
                          validation.touched.password && validation.errors.password ? true : false
                        }
                      />
                      <button
                        type="button"
                        className="password-toggle-btn"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        <i className={`mdi ${showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'}`}></i>
                      </button>
                      {validation.touched.password && validation.errors.password ? (
                        <FormFeedback className="error-text">{validation.errors.password}</FormFeedback>
                      ) : null}
                    </div>

                    <button className="btn glassmorphic-btn" type="submit">
                      Register
                    </button>

                    <p className="terms-text">
                      By registering you agree to the{' '}
                      <Link to="#" className="glassmorphic-link">Terms of Use</Link>
                    </p>

                    <div className="login-text">
                      Already have an account?{' '}
                      <Link to="/login" className="login-link">
                        Login
                      </Link>
                    </div>
                  </Form>
                </CardBody>
              </Card>

              {/* Decorative circles */}
              <div className="decorative-circle-1"></div>
              <div className="decorative-circle-2"></div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Register